//---------------------SAGA------------------------------
export const GET_ALL_PROJECT_API = "GET_ALL_PROJECT_API";

// --------------------ACTION----------------------------------
export const GET_ALL_PROJECT_ACTION = "GET_ALL_PROJECT_ACTION";